import React, { useEffect, useImperativeHandle, useState } from 'react';
import { Button, Modal, Space } from 'antd';
import DeleteButton from '../../../components/DeleteButton'; 
import './styles.less';
import { useWatch } from 'antd/es/form/Form';

const FormSaveCancelToolbar = ( { form, modified, saveCallback, cancelCallback, saving, open, ref,
    showCancelButton, hideReset, showDeleteButton = false, deleteCallback, fieldNames = false } ) => {

    const [ hasErrors, setHasErrors ] = useState( false );

    const fields = useWatch( [], form );

    function validate() {
        form.validateFields( fieldNames, { validateOnly: true } )
            .then( x => 
                setHasErrors( false ) )
            .catch( e => 
                setHasErrors( true ) );
    }

    useEffect( () => {

        if ( fieldNames === false ) {
            return;
        }

        validate();
        
    }, [ fields ] );

    useImperativeHandle( ref, () => ( {
        triggerValidation: () => validate()
    } ) );

    return (
        <Space 
            className="form-save-cancel-toolbar"
            direction="vertical" 
            size="small"
        >
            <Modal 
                title="Save Changes?" 
                open={ open } 
                onOk={ saveCallback } 
                onCancel={ cancelCallback }
                okText="Yes"
                cancelText="No"
            >
                <p>Do you want to save your changes?</p>
                <p>If you click No will lose your unsaved changes.</p>
            </Modal>
            
            <Button
                type="primary"
                disabled={ !modified || saving || hasErrors }
                onClick={ saveCallback }
            >
                Save
            </Button>
             
            { hideReset && 
                <Button
                    disabled={ !modified || saving }
                    onClick={ cancelCallback }
                >
                    Reset
                </Button>
            }

            { showCancelButton && 
                <Button
                    disabled={ saving }
                    onClick={ () => window.history.back() }
                >
                    Cancel
                </Button>
            }

            { showDeleteButton && 
                <DeleteButton 
                    disabled={ saving }
                    danger 
                    onDelete={ deleteCallback }
                    confirmMessage= { 
                        <React.Fragment>
                            <p>Are you <i>sure</i> you want to delete this?</p>
                        </React.Fragment>
                    }
                >
                    Delete
                </DeleteButton>
            }
        </Space>
    );
};

export default FormSaveCancelToolbar;
